document.addEventListener("DOMContentLoaded", function () {
  try {
    // -------------------------
    // CONFIG (edítalo según necesites)
    // -------------------------
    var TARGET_MAP = {
      "/collections/guaguas-0m-6m": [
        { label: "Ropa Bebé Niña", url: "/collections/baby-girl-clothes" },
        { label: "Ropa Bebé Niño", url: "/collections/baby-boys" },
        { label: "Enteritos y Pijamas Niña", url: "/collections/enteritos-nina" },
        { label: "Enteritos y Pijamas Niño", url: "/collections/enteritos-nino" },
        { label: "Bodys y Básicos Pima", url: "/collections/bodys-y-basicos-pima" },
        { label: "Accesorios", url: "/collections/accesorios" },
        { label: "Zapatitos Bebé (15–19)", url: "/collections/baby-shoes" }
      ],
      "/collections/girls-collection-3m-12a": [
        { label: "Vestidos y Jumpers", url: "/collections/vestidos-y-jumpers" },
        { label: "Tops y Blusas", url: "/collections/tops-y-blusas" },
        { label: "Chalecos y Sweaters", url: "/collections/chalecos-y-sweaters-girls" },
        { label: "Pantalones", url: "/collections/pantalones" },
        { label: "Shorts y Faldas", url: "/collections/shorts-y-faldas" },
        { label: "Abrigos", url: "/collections/abrigos" },
        { label: "Zapatos Niñitas (17–33)", url: "/collections/girls-shoes" },
        { label: "Accesorios", url: "/collections/accesorios" }
      ],
      "/collections/boys-collection-3m-10a": [
        { label: "Camisas y Poleras", url: "/collections/camisas-y-poleras" },
        { label: "Chalecos y Sweaters", url: "/collections/chalecos-y-sweaters-boys" },
        { label: "Pantalones y Shorts", url: "/collections/pantalones-y-shorts" },
        { label: "Zapatos Niños (17–32)", url: "/collections/boys-shoes" },
        { label: "Accesorios", url: "/collections/accesorios" }
      ],

      // --- NUEVAS COLECCIONES SOLICITADAS ---
      "/collections/ceremony-collection": [
        { label: "Niño", url: "/collections/boys" },
        { label: "Niña", url: "/collections/girls" }
      ],

      "/collections/shoes-collection": [
        { label: "Zapatitos bebé", url: "/collections/baby-shoes" },
        { label: "Niñitas", url: "/collections/girls-shoes" },
        { label: "Niños", url: "/collections/boys-shoes" },
        { label: "Ballenas", url: "/collections/ballerinas" },
        { label: "Calcetines", url: "/collections/calcetines" }
      ]
    };
    // -------------------------
    // End CONFIG
    // -------------------------

    function normalizePath(p) {
      if (!p) return "";
      try {
        var u = new URL(p, window.location.origin);
        return (u.pathname || "").replace(/\/$/, "").toLowerCase();
      } catch (e) {
        return (p + "").replace(/\/$/, "").toLowerCase();
      }
    }

    var currentPath = normalizePath(window.location.pathname || window.location.href);

    // Encontrar la key que coincide con la URL de la colección actual
    var matchKey = null;
    var matchedIndex = -1; // index de la subcategoria activa

    for (var key in TARGET_MAP) {
      if (!Object.prototype.hasOwnProperty.call(TARGET_MAP, key)) continue;

      var mainPath = normalizePath(key);

      // a) si coincide con la categoría principal
      if (mainPath === currentPath) {
        matchKey = key;
        matchedIndex = -1;
        break;
      }

      // b) buscamos coincidencia con subcategorías
      var subcats = TARGET_MAP[key];
      for (var i = 0; i < subcats.length; i++) {
        var subPath = normalizePath(subcats[i].url);
        if (subPath === currentPath) {
          matchKey = key;
          matchedIndex = i; // encontramos qué subcat está activa
          break;
        }
      }

      if (matchKey) break;
    }

    // si no coincide ni con categoría principal ni subcategoría → no mostrar nada
    if (!matchKey) return;

    // clonamos para no modificar el original
    var items = TARGET_MAP[matchKey].slice();

    // si es subcategoría → moverla a primer lugar
    if (matchedIndex > -1) {
      var active = items.splice(matchedIndex, 1)[0];
      items.unshift(active);
    }

    var container = document.getElementById("auto-subcats-container");
    if (!container) return;

    var inner = document.createElement("div");
    inner.className = "auto-subcats-inner";
    inner.setAttribute("role", "navigation");
    inner.setAttribute("aria-label", "Subcategorías de la colección");
    inner.setAttribute("tabindex", "0");

    items.forEach(function (it) {
      if (!it || !it.url) return;
      var label = (it.label || it.url || "").toString().trim();
      if (!label) return;
      var key = label.toLowerCase();
      if (key === "ver todo" || key === "ver-todo" || key === "ver_todo") return;

      var a = document.createElement("a");
      a.className = "auto-subcat-pill";
      a.href = it.url;
      a.textContent = it.label || it.url;

      try {
        var itemPath = normalizePath(it.url);
        if (itemPath === currentPath) a.classList.add("is-active");
      } catch (e) {}

      inner.appendChild(a);
    });

    if (!inner.children.length) return;

    container.appendChild(inner);
    container.style.display = "";
    container.setAttribute("aria-hidden", "false");

    // Si movimos una coincidencia al primer puesto, forzamos que la primera pastilla sea active
    if (matchedIndex > -1) {
      var firstPill = inner.querySelector(".auto-subcat-pill");
      if (firstPill) firstPill.classList.add("is-active");
      try {
        firstPill.scrollIntoView({ behavior: "smooth", inline: "start", block: "nearest" });
      } catch (e) { /* no crítico */ }
    }

    // --- Drag & touch & keyboard (mejorado con momentum/inercia) ---
    (function enableDragAndKeys(el) {
      var isDown = false, startX = 0, scrollLeft = 0;

      // Variables para inercia
      var lastX = 0, lastT = 0;
      var velocity = 0;
      var animId = null;

      function cancelMomentum() {
        if (animId) {
          cancelAnimationFrame(animId);
          animId = null;
        }
      }

      function beginDrag(pageX) {
        cancelMomentum();
        isDown = true;
        startX = pageX - el.offsetLeft;
        scrollLeft = el.scrollLeft;
        lastX = pageX;
        lastT = performance.now();
        velocity = 0;
        el.classList.add("is-dragging");
      }

      function moveDrag(pageX) {
        if (!isDown) return;
        var x = pageX - el.offsetLeft;
        var dx = x - startX;
        el.scrollLeft = scrollLeft - dx;

        // calcular velocidad (px per ms) con un suavizado básico
        var now = performance.now();
        var dt = now - lastT || 16;
        var dxv = pageX - lastX;
        var instV = dxv / dt;
        // suavizado exponencial ligero
        velocity = velocity * 0.8 + instV * 0.2;
        lastX = pageX;
        lastT = now;
      }

      function endDrag() {
        if (!isDown) return;
        isDown = false;
        el.classList.remove("is-dragging");

        // si la velocidad es significativa, aplicar momentum
        // velocity is px/ms; convert to px/second by *1000 if needed, but we use px/ms directly
        var v = velocity;
        var amplitude = v; // px per ms baseline
        var frameLast = performance.now();

        // deceleration params
        var decay = 0.95; // multiplicative decay per frame (tuneable)
        var minVelocity = 0.02; // px/ms threshold to stop (tuneable)

        cancelMomentum();

        // animate using requestAnimationFrame with time-based integration
        function step(ts) {
          var dt = ts - frameLast;
          frameLast = ts;

          // apply simple inertia: move by velocity * dt
          el.scrollLeft -= amplitude * dt;

          // decay amplitude over time
          amplitude *= Math.pow(decay, dt / 16.67); // scale decay based on time

          // stop condition
          if (Math.abs(amplitude) > minVelocity) {
            animId = requestAnimationFrame(step);
          } else {
            animId = null;
          }
        }

        // start only if velocity notable
        if (Math.abs(amplitude) > minVelocity) {
          animId = requestAnimationFrame(step);
        }
      }

      // MOUSE events
      el.addEventListener("mousedown", function (e) {
        beginDrag(e.pageX);
        e.preventDefault();
      });

      document.addEventListener("mousemove", function (e) {
        moveDrag(e.pageX);
      });

      document.addEventListener("mouseup", function () {
        endDrag();
      });

      // TOUCH events
      el.addEventListener("touchstart", function (e) {
        if (!e.touches || !e.touches[0]) return;
        beginDrag(e.touches[0].pageX);
      }, { passive: true });

      el.addEventListener("touchmove", function (e) {
        if (!e.touches || !e.touches[0]) return;
        moveDrag(e.touches[0].pageX);
      }, { passive: true });

      el.addEventListener("touchend", function () {
        endDrag();
      });

      // keyboard arrows
      el.addEventListener("keydown", function (e) {
        if (e.key === "ArrowRight" || e.key === "ArrowLeft") {
          e.preventDefault();
          var step = Math.round(el.clientWidth * 0.2);
          el.scrollBy({ left: e.key === "ArrowRight" ? step : -step, behavior: "smooth" });
        }
      });

      // make pills focusable
      var pills = el.querySelectorAll(".auto-subcat-pill");
      pills.forEach(function (p) { p.setAttribute("tabindex", "0"); });
    })(inner);

    // Centrar si desktop y hay overflow (opcional)
    function centerIfDesktop() {
      if (window.innerWidth < 1025) return;
      if (inner.scrollWidth > inner.clientWidth) {
        inner.scrollLeft = Math.round((inner.scrollWidth - inner.clientWidth) / 2);
      } else {
        inner.scrollLeft = 0;
      }
    }
    centerIfDesktop();
    var to; window.addEventListener("resize", function () { clearTimeout(to); to = setTimeout(centerIfDesktop, 120); });

  } catch (err) {
    console.error("STUDIO IB - subcats error:", err);
  }
});
